import React, { useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="border-t border-white/10 bg-[#05070d] py-8" data-id="element-34">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-35">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-36">
            <div className="text-gray-400 text-sm" data-id="element-37">
              © 2024 Protocolo Ex-Back AI. Todos los derechos reservados.
            </div>
            <div className="flex gap-6 text-sm" data-id="element-38">
              <button onClick={() => setShowPrivacy(true)} className="text-gray-400 hover:text-[#00d9ff] transition-colors" data-id="element-39">
                Política de Privacidad
              </button>
              <button onClick={() => setShowTerms(true)} className="text-gray-400 hover:text-[#00d9ff] transition-colors" data-id="element-40">
                Términos de Servicio
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <AnimatePresence data-id="element-41">
        {showPrivacy && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[100] flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-42">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} className="bg-[#0a0e1a] border border-[#00d9ff]/30 rounded-2xl max-w-3xl w-full max-h-[80vh] overflow-y-auto p-8 relative" onClick={e => e.stopPropagation()} data-id="element-43">
              <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-44">
                <X className="w-6 h-6" data-id="element-45" />
              </button>

              <h2 className="text-3xl font-bold mb-6 text-[#00d9ff]" data-id="element-46">
                Política de Privacidad
              </h2>

              <div className="space-y-6 text-gray-300 leading-relaxed" data-id="element-47">
                <section data-id="element-48">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-49">
                    1. Información que Recopilamos
                  </h3>
                  <p data-id="element-50">
                    Al adquirir el Protocolo Ex-Back AI, recopilamos únicamente
                    la información necesaria para procesar tu compra y
                    entregarte el producto digital. Esto incluye tu dirección de
                    correo electrónico y datos de pago procesados de forma
                    segura a través de nuestro proveedor de pagos.
                  </p>
                </section>

                <section data-id="element-51">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-52">
                    2. Uso de la Información
                  </h3>
                  <p data-id="element-53">Tu información se utiliza exclusivamente para:</p>
                  <ul className="list-disc list-inside ml-4 mt-2 space-y-1" data-id="element-54">
                    <li data-id="element-55">Procesar tu compra y entregar el producto</li>
                    <li data-id="element-56">Enviar actualizaciones sobre tu pedido</li>
                    <li data-id="element-57">Proporcionar soporte al cliente cuando lo solicites</li>
                  </ul>
                </section>

                <section data-id="element-58">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-59">
                    3. Protección de Datos
                  </h3>
                  <p data-id="element-60">
                    Implementamos medidas de seguridad estándar de la industria
                    para proteger tu información personal. Todos los datos de
                    pago son procesados a través de plataformas seguras y
                    encriptadas. Nunca almacenamos información de tarjetas de
                    crédito en nuestros servidores.
                  </p>
                </section>

                <section data-id="element-61">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-62">
                    4. Confidencialidad
                  </h3>
                  <p data-id="element-63">
                    Entendemos la naturaleza sensible del contenido del
                    Protocolo Ex-Back AI. Tu privacidad es nuestra prioridad. No
                    compartimos, vendemos ni distribuimos tu información
                    personal a terceros, excepto cuando sea necesario para
                    procesar pagos o cumplir con requisitos legales.
                  </p>
                </section>

                <section data-id="element-64">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-65">
                    5. Cookies y Tecnologías de Seguimiento
                  </h3>
                  <p data-id="element-66">
                    Utilizamos cookies básicas para mejorar tu experiencia de
                    navegación y analizar el tráfico del sitio web. Puedes
                    desactivar las cookies en la configuración de tu navegador,
                    aunque esto puede afectar algunas funcionalidades del sitio.
                  </p>
                </section>

                <section data-id="element-67">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-68">
                    6. Tus Derechos
                  </h3>
                  <p data-id="element-69">Tienes derecho a:</p>
                  <ul className="list-disc list-inside ml-4 mt-2 space-y-1" data-id="element-70">
                    <li data-id="element-71">Acceder a tu información personal</li>
                    <li data-id="element-72">Solicitar la corrección de datos inexactos</li>
                    <li data-id="element-73">Solicitar la eliminación de tu información</li>
                    <li data-id="element-74">Retirar tu consentimiento en cualquier momento</li>
                  </ul>
                </section>

                <section data-id="element-75">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-76">
                    7. Contacto
                  </h3>
                  <p data-id="element-77">
                    Si tienes preguntas sobre esta Política de Privacidad o
                    deseas ejercer tus derechos, contáctanos a través del correo
                    electrónico proporcionado en tu compra.
                  </p>
                </section>

                <p className="text-sm text-gray-500 mt-8" data-id="element-78">
                  Última actualización: Marzo 2024
                </p>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* Terms of Service Modal */}
      <AnimatePresence data-id="element-79">
        {showTerms && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[100] flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-80">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} className="bg-[#0a0e1a] border border-[#00d9ff]/30 rounded-2xl max-w-3xl w-full max-h-[80vh] overflow-y-auto p-8 relative" onClick={e => e.stopPropagation()} data-id="element-81">
              <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-82">
                <X className="w-6 h-6" data-id="element-83" />
              </button>

              <h2 className="text-3xl font-bold mb-6 text-[#00d9ff]" data-id="element-84">
                Términos de Servicio
              </h2>

              <div className="space-y-6 text-gray-300 leading-relaxed" data-id="element-85">
                <section data-id="element-86">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-87">
                    1. Aceptación de Términos
                  </h3>
                  <p data-id="element-88">
                    Al adquirir y utilizar el Protocolo Ex-Back AI, aceptas
                    estos Términos de Servicio en su totalidad. Si no estás de
                    acuerdo con alguna parte de estos términos, no debes
                    utilizar este producto.
                  </p>
                </section>

                <section data-id="element-89">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-90">
                    2. Descripción del Producto
                  </h3>
                  <p data-id="element-91">
                    El Protocolo Ex-Back AI es un producto digital educativo que
                    proporciona estrategias y plantillas de comunicación basadas
                    en principios psicológicos. El producto incluye:
                  </p>
                  <ul className="list-disc list-inside ml-4 mt-2 space-y-1" data-id="element-92">
                    <li data-id="element-93">Manual Maestro Protocolo Ex-Back AI</li>
                    <li data-id="element-94">5 Plantillas "Rompehielo"</li>
                    <li data-id="element-95">La Regla del Espejo</li>
                    <li data-id="element-96">Auditoría de Perfil Digital</li>
                    <li data-id="element-97">Guía de FAQ de Emergencia</li>
                  </ul>
                </section>

                <section data-id="element-98">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-99">
                    3. Limitación de Responsabilidad
                  </h3>
                  <p data-id="element-100">
                    El Protocolo Ex-Back AI es una herramienta educativa y de
                    orientación. No garantizamos resultados específicos, ya que
                    cada situación personal es única. Los resultados pueden
                    variar según las circunstancias individuales, el esfuerzo
                    aplicado y factores externos fuera de nuestro control.
                  </p>
                </section>

                <section data-id="element-101">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-102">
                    4. Uso Apropiado
                  </h3>
                  <p data-id="element-103">
                    Este producto NO debe utilizarse en situaciones que
                    involucren:
                  </p>
                  <ul className="list-disc list-inside ml-4 mt-2 space-y-1" data-id="element-104">
                    <li data-id="element-105">Relaciones con historial de abuso físico o verbal</li>
                    <li data-id="element-106">Órdenes de alejamiento o restricciones legales</li>
                    <li data-id="element-107">Acoso o comportamiento no consensuado</li>
                    <li data-id="element-108">Manipulación dañina o control coercitivo</li>
                  </ul>
                  <p className="mt-2" data-id="element-109">
                    El usuario es responsable de utilizar el contenido de manera
                    ética y legal.
                  </p>
                </section>

                <section data-id="element-110">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-111">
                    5. Propiedad Intelectual
                  </h3>
                  <p data-id="element-112">
                    Todo el contenido del Protocolo Ex-Back AI está protegido
                    por derechos de autor. Al adquirir el producto, obtienes una
                    licencia personal no transferible para uso individual. Está
                    prohibido:
                  </p>
                  <ul className="list-disc list-inside ml-4 mt-2 space-y-1" data-id="element-113">
                    <li data-id="element-114">Compartir, distribuir o revender el contenido</li>
                    <li data-id="element-115">Publicar el material en plataformas públicas</li>
                    <li data-id="element-116">Modificar y redistribuir como producto propio</li>
                  </ul>
                </section>

                <section data-id="element-117">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-118">
                    6. Política de Reembolsos
                  </h3>
                  <p data-id="element-119">
                    Debido a la naturaleza digital del producto y el acceso
                    instantáneo al contenido completo tras la compra, no
                    ofrecemos reembolsos. Te recomendamos leer cuidadosamente la
                    descripción del producto antes de realizar tu compra.
                  </p>
                </section>

                <section data-id="element-120">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-121">
                    7. Descargo de Responsabilidad Profesional
                  </h3>
                  <p data-id="element-122">
                    El Protocolo Ex-Back AI no sustituye el asesoramiento
                    profesional de terapeutas, psicólogos o consejeros
                    matrimoniales. Si experimentas problemas emocionales graves,
                    te recomendamos buscar ayuda profesional calificada.
                  </p>
                </section>

                <section data-id="element-123">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-124">
                    8. Modificaciones
                  </h3>
                  <p data-id="element-125">
                    Nos reservamos el derecho de modificar estos términos en
                    cualquier momento. Los cambios entrarán en vigor
                    inmediatamente después de su publicación. El uso continuado
                    del producto después de las modificaciones constituye tu
                    aceptación de los nuevos términos.
                  </p>
                </section>

                <section data-id="element-126">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-127">
                    9. Jurisdicción
                  </h3>
                  <p data-id="element-128">
                    Estos términos se rigen por las leyes aplicables en la
                    jurisdicción donde opera el negocio. Cualquier disputa se
                    resolverá en los tribunales competentes de dicha
                    jurisdicción.
                  </p>
                </section>

                <p className="text-sm text-gray-500 mt-8" data-id="element-129">
                  Última actualización: Marzo 2024
                </p>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}